import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { api } from "@/lib/api";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    api.get("/auth/me").then(() => navigate("/admin/dashboard")).catch(() => {});
  }, [navigate]);

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await api.post("/auth/login", { email, password });
      navigate("/admin/dashboard");
    } catch (err) {
      setError(err.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-canvas px-4" data-testid="admin-login-page">
      <div className="noise-overlay" />
      <motion.form
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        onSubmit={onSubmit}
        className="w-full max-w-md rounded-2xl border border-white/10 bg-card p-10"
        data-testid="admin-login-form"
      >
        <p className="font-display text-2xl font-extrabold uppercase text-ink">Noste<span className="text-accent">.</span></p>
        <p className="mt-1 font-mono text-xs uppercase tracking-[0.25em] text-dim">Admin</p>

        <label className="mb-2 mt-8 block font-mono text-[10px] uppercase tracking-[0.25em] text-dim">Email</label>
        <input
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className="w-full rounded-lg border border-white/10 bg-canvas px-4 py-3.5 text-sm text-ink outline-none transition-colors focus:border-accent"
          data-testid="admin-login-email-input"
        />
        <label className="mb-2 mt-5 block font-mono text-[10px] uppercase tracking-[0.25em] text-dim">Password</label>
        <input
          type="password"
          required
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          className="w-full rounded-lg border border-white/10 bg-canvas px-4 py-3.5 text-sm text-ink outline-none transition-colors focus:border-accent"
          data-testid="admin-login-password-input"
        />

        {error && (
          <p className="mt-4 font-mono text-xs uppercase tracking-widest text-red-400" data-testid="admin-login-error">{error}</p>
        )}

        <button
          type="submit"
          disabled={loading}
          className="mt-8 w-full rounded-full bg-accent px-7 py-4 font-mono text-xs font-bold uppercase tracking-[0.15em] text-canvas transition-transform duration-300 hover:scale-[1.02] disabled:opacity-60"
          data-testid="admin-login-submit-button"
        >
          {loading ? "…" : "Login"}
        </button>

        <a href="/" className="mt-6 block text-center font-mono text-[10px] uppercase tracking-[0.2em] text-dim transition-colors hover:text-accent" data-testid="admin-back-to-site">
          ← noste.fi
        </a>
      </motion.form>
    </div>
  );
}
